<template>
    <v-autocomplete
        v-bind="$attrs"
        :value="value"
        :items="items"
        item-value="id"
        item-text="name"
        no-filter
        :search-input.sync="search"
        :menu-props="mergedMenuProps"
        v-on="listeners"
    ></v-autocomplete>
</template>
<script>
import { groupTeamsForSelect } from '@/utils/teamGroups'
export default {
    name: 'TeamPicker',
    inheritAttrs: false,
    props: {
        value: {
            type: [Number, Array],
            default: null,
        },
        teams: {
            type: Array,
            default: null,
        },
        showAll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            search: '',
        }
    },
    computed: {
        sourceTeams() {
            const source = this.teams != null ? this.teams : this.$store.getters.teams()
            const storeTeams = this.$store.getters.teams() || []
            const groupById = {}
            storeTeams.forEach(t => {
                groupById[t.id] = t.group
            })
            return (source || []).map(t => {
                const id = t.id != null ? t.id : t.value
                const group = t.group !== undefined ? t.group : id in groupById ? groupById[id] : null
                return {
                    id,
                    name: t.name != null ? t.name : t.text,
                    group,
                }
            })
        },
        selectedName() {
            // For a single-select v-autocomplete, opening the menu populates the search input
            // with the selected item's text. We must not treat that as a user search query.
            if (Array.isArray(this.value)) return null
            if (this.value === 0) return 'All'
            const match = this.sourceTeams.find(t => t.id === this.value)
            return match ? match.name : null
        },
        filteredTeams() {
            if (!this.search || this.search === this.selectedName) return this.sourceTeams
            const q = this.search.toLowerCase()
            return this.sourceTeams.filter(t => (t.name || '').toLowerCase().includes(q))
        },
        items() {
            const leadingItems = this.showAll ? [{ id: 0, name: 'All' }] : []
            return groupTeamsForSelect(this.filteredTeams, { leadingItems })
        },
        listeners() {
            return { ...this.$listeners, input: this.onInput }
        },
        mergedMenuProps() {
            const passed = this.$attrs['menu-props'] || this.$attrs.menuProps || {}
            const contentClass = ['team-picker-menu', passed.contentClass].filter(Boolean).join(' ')
            return { ...passed, contentClass }
        },
    },
    methods: {
        onInput(val) {
            this.search = ''
            this.$emit('input', val)
        },
    },
}
</script>
<style>
/* NOT scoped: the v-autocomplete menu is teleported to <body>; a scoped style cannot reach it.
   Namespaced by the menu contentClass so it leaks to nothing else. */
.team-picker-menu .v-subheader {
    background-color: #e8eaf0;
    color: rgba(0, 0, 0, 0.82);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    font-size: 0.7rem;
    height: 26px;
    align-items: center;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    position: sticky;
    top: 0;
    z-index: 1;
}
</style>
